class GeneralStyle {

    constructor() {

        this.normal = {

            AppContent: {
                backgroundColor: "#2d2d2d",
                alignText: "center",
                alignContent: "center",
            },
            Container: {
                width: "90%",
                textAlign: "center",
                alignContent: "center",
                marginTop: 40,
                fontFamily: "'Libre Franklin'",
                color: "#e0e0e0",
                marginLeft: "auto",
                marginRight: "auto",
            },
            IdBanner: {
                photo: {
                    backgroundImage: "url('/assets/back.png')",
                },
                IdBox0: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "320px",
                },
                IdBoxA: {
                    display: "flex",
                    flexDirection: "row",
                },
                IdBoxB: {
                    display: "flex",
                    flexDirection: "column",
                    flexBasis: "50%",
                    alignItems: "flex-end",
                    justifyContent: "center",
                },
                IdBoxC: {
                    display: "flex",
                    flexDirection: "column",
                    flexBasis: "50%",
                    justifyContent: "center",
                },
                IdBoxD: {
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    justifyContent: "space-around",
                    height: "232px",
                    width: "480px",
                    backgroundColor: "rgba(51,51,51,0.8)",
                },
                rhawBoxColumns: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                },
                rhawlogo: {
                    justifyContent: "center",
                },
                rhawadjectives: {
                    height: "75%",
                    display: "flex",
                    justifyContent: "space-around",
                    flexDirection: "column",
                    alignContent: "center",
                },
                rhawadjective: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    textAlign: "center",
                },
                rhawadjectiveText: {
                    fontsize: "24px",
                    color: "ivory",
                    marginLeft: "10px",
                },
            },
            Header: {
                marginLeft: 0,
                textAlign: "left",
                Title: {
                    textDecoration: 'underline',
                    marginTop: 0,
                    marginBottom: 5,
                    fontSize: 20,
                    color: "#e59409",
                },
                section: {
                    width: "100%",
                    textAlign: "center",
                    alignContent: "center",
                },
                name: {
                    textTransform: "uppercase",
                    fontWeight: 700,
                    fontSize: 24,
                    width: "100%",
                    textAlign: "center",
                    alignContent: "center",
                    padding: 0,
                    margin: 0,
                    marginBottom: 5,
                },
                address: {
                    width: "100%",
                    textAlign: "center",
                    alignContent: "center",
                    padding: 0,
                    margin: 0,
                    color: "#c0c0c0"
                },
                email: {
                    width: "100%",
                    textAlign: "center",
                    alignContent: "center",
                    padding: 0,
                    margin: 0,
                    color: "#c0c0c0"
                },
                phone: {
                    width: "100%",
                    textAlign: "center",
                    alignContent: "center",
                    padding: 0,
                    margin: 0,
                    color: "#c0c0c0"
                },
            },
            Body: {
                width: "95%",
                textAlign: "center",
                marginLeft: "auto",
                marginRight: "auto",
                padding:0,
                Introduction: {
                    width: "100%",
                    textAlign: "left",
                    margin: 0,
                    padding: 0,
                    title: {
                        textTransform: "uppercase",
                        fontWeight: 700,
                        width: "100%",
                        textAlign: "left",
                        marginBottom: 5,
                    },
                    text: {

                    },
                },
                Section: {
                    width: "100%",
                    textAlign: "left",
                    margin: 0,
                    padding: 0,
                    title: {
                        textTransform: "uppercase",
                        fontWeight: 700,
                        width: "100%",
                        textAlign: "left",
                        marginBottom: 5,
                    },
                    text: {
                        textAlign: "left",
                        margin: 0,
                        padding: 0,
                    },
                    subsection: {
                        width: "90%",
                        marginLeft: "auto",
                        marginRight: "auto",
                        padding: 0,
                        title: {
                            fontWeight: "normal",
                            fontStyle: "italic",
                            textTransform: "capitalize",
                            width: "100%",
                            textAlign: "left",
                            marginBottom: 0,
                        },
                    }
                },
                TextPage: {
                    Section: {
                        width: "100%",
                        textAlign: "left",
                        margin: 0,
                        marginTop: 12,
                        marginBottom: 12,
                        padding: 0,
                        title: {
                            textTransform: "uppercase",
                            fontWeight: 700,
                            width: "100%",
                            textAlign: "left",
                            marginBottom: 5,
                        },
                        text: {
                            textAlign: "left",
                            margin: 0,
                            padding: 0,
                        },
                        anchor: {
                            normal: {
                                textDecoration: 'underline',
//                            color: "#ED69C0",
                                color: "#02b8ef",
                            },
                            hover: {
                                textDecoration: 'underline',
                                cursor: "pointer",
//                            color: "#AE4280",
                                color: "#0197c4",
                            },
                        },
                        subsection: {
                            width: "90%",
                            marginLeft: "auto",
                            marginRight: "auto",
                            padding: 0,
                            title: {
                                fontWeight: "normal",
                                fontStyle: "italic",
                                textTransform: "capitalize",
                                width: "100%",
                                textAlign: "left",
                                marginBottom: 0,
                            },
                        },
                        paragraph: {
                            width: "100%",
                            marginLeft: 0,
                            marginTop: 5,
                            marginBottom: 5,
                            padding: 0,
                            textIndent: "30px",
                            title: {
                                fontWeight: "normal",
                                fontStyle: "italic",
                                textTransform: "capitalize",
                                width: "100%",
                                textAlign: "left",
                                marginBottom: 0,
                            },
                        },
                    },
                },
                AppsPage: {
                    AppSection : {
                        container: {
                            width: "100%",
                            textAlign: "left",
                            margin: 0,
                            marginTop: 12,
                            marginBottom: 12,
                            padding: 5,
                            borderRadius: 4,
                            border: "2px solid black",
                            backgroundColor: "black",
                            display: "flex",
                            flex: "wrap",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                        },
                        columns: {
                            width: "100%",
                            textAlign: "left",
                            margin: 0,
                            marginTop: 12,
                            marginBottom: 12,
                            padding: 5,
                            borderRadius: 4,
                            border: "2px solid black",
                            backgroundColor: "black",
                            display: "flex",
                            flex: "wrap",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                        },
                        Logo: {
                            normal: {
                                height: "200px",
                                width: "200px",
                                flex: "none",
                                borderRadius: 4,
                                border: "2px solid #AE4280",
                            },
                            hover: {
                                height: "200px",
                                width: "200px",
                                flex: "none",
                                borderRadius: 4,
                                border: "2px solid #ED69C0",
                            },
                        },

                        QCode: {

                        },
                        TextSection: {
                            container: {
                                display: "flex",
                                flex: "nowrap",
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                textAlign: "left",
                                marginLeft: 10,
                            },
                            title: {
                                textTransform: "uppercase",
                                textDecoration: 'underline',
                                fontWeight: 700,
                                width: "100%",
                                textAlign: "left",
                                marginBottom: 0,
                            },
                            subtitle: {
                                width: "100%",
                                textAlign: "left",
                                marginBottom: 0,
                                marginTop: 5,
                            },
                            description: {
                                marginTop: 5,
                                textIndent: "20px",
                            },
                            storelink: {

                            },
                            technology: {

                            }
                        },
                    },
                },
            },
            ContactPage: {
                Container: {
                    width: "100%",
                    alignText: "center",
                    alignContent: "center",
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap"
                },
                SubContainer: {
                    width: "80%",
                    backgroundColor: "#FFF",
                    borderRadius: 3,
                    paddingBottom: 10,
                    paddingTop: 20,
                    display: "flex",
                    justifyContent: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                },
                SubSubContainer: {
                    width: "80%",
                    backgroundColor: "#FFF",
                    borderRadius: 3,
                    paddingBottom: 10,
                    paddingTop: 20,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-evenly",
                },
                Header: {
                    width: "100%",
                    color: "#333",
                    fontWeight: "bold",
                    textAlign: 'center',
                    fontSize: 24,
                },
                Field: {
//                    width: 450,
                    paddingTop: 5,
                    paddingBottom: 5,
                    paddingLeft: 10,
                    marginTop: 5,
                    marginLeft: "auto",
                    marginRight: "auto",
                },
                Submit: {
                    cursor: "pointer",
                    backgroundColor: "#4CAF50", /* Green */
                    border: "none",
                    borderRadius: 4,
                    color: "white",
                    padding: "15px 32px",
                    textAlign: "center",
                    textDecoration: "none",
                    display: "inline-block",
                    fontSize: 16,
                    width: 100,
                    marginTop: 6,
                    marginLeft: "auto",
                    marginRight: "auto",
                },
                SubmitHover: {
                    cursor: "pointer",
                    backgroundColor: "#4CAF50", /* Green */
                    border: "none",
                    borderRadius: 4,
                    color: "black",
                    padding: "15px 32px",
                    textAlign: "center",
                    textDecoration: "none",
                    display: "inline-block",
                    fontSize: 16,
                    width: 100,
                    marginTop: 6,
                    marginLeft: "auto",
                    marginRight: "auto",
                },
                CenteredGraph: {
                    width: "100%",
                    textAlign: 'center',
                    marginTop: 5,
                }
            },
            Card: {
                grid: {
                    marginTop: 20,
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap"
                },
                gridItem: {
                    border: "1px solid #fff",
                    margin: 10
                },
                card: {
                    backgroundColor: "#EEE",
                    padding: 0,
                    height: "100%",
                    width: 289,
                },
                content: {
                    padding: 5
                },
                title: {
                    fontSize: 20,
                    fontWeight: "bold",
                    color: "#333",
                    marginBottom: 4,
                    fontFamily: "Muli",
                    textTransform: "uppercase",
                },
                subtitle: {
                    color: "#333",
                    fontFamily: "Fira Sans"
                },
                description: {
                    fontSize: 14,
                    color: "#333",
                    fontFamily: "Fira Sans",
                    wordWrap: "break-word"
                },
                detail: {
                    text: {
                        fontSize: 14,
                        color: "#333",
                        fontFamily: "Fira Sans",
                    },
                    anchor: {
                        normal: {
                            textDecoration: 'underline',
//                            color: "#ED69C0",
                            color: "#02b8ef",
                        },
                        hover: {
                            textDecoration: 'underline',
                            cursor: "pointer",
//                            color: "#AE4280",
                            color: "#0197c4",
                        },
                    },
                },
            },
        }

        // width < 321
        this.smallest = this.deepClone(this.normal, null);
        this.smallest.Header.Title.fontSize = 18;
        this.normal.Body.width = "98%";
        this.smallest.Body.Section.width= "98%";
        this.smallest.ContactPage.Field.width = "98%";
        this.smallest.ContactPage.SubContainer.width = "98%";
        this.smallest.ContactPage.SubSubContainer.width = "98%";
        this.smallest.Body.AppsPage.AppSection.container.width = "98%";
        this.smallest.Body.AppsPage.AppSection.container.padding = 0;
        this.smallest.Body.AppsPage.AppSection.container.flexDirection = "column";
        this.smallest.Body.AppsPage.AppSection.container.justifyContent = "flex-center";

        // width < 481
        this.small = this.deepClone(this.normal, null);
        this.small.Header.Title.fontSize = 18;
        this.small.Body.Section.width= "92%";
        this.small.ContactPage.Field.width = "92%";
        this.small.ContactPage.SubContainer.width = "92%";
        this.small.ContactPage.SubSubContainer.width = "92%";
        this.small.Body.AppsPage.AppSection.container.width = "98%";
        this.small.Body.AppsPage.AppSection.container.padding = 0;
        this.small.Body.AppsPage.AppSection.container.flexDirection = "column";

        // width < 769
        this.medium = this.deepClone(this.normal, null);
        this.medium.ContactPage.Field.width = "90%";

        //width > 1025
        this.largest = this.deepClone(this.normal, null);

        //width < 1025
        this.currStyles = this.normal;
    }

    deepClone(initalObj, finalObj) {
        var obj = finalObj || {};
        for (var i in initalObj) {
            var prop = initalObj[i];

            if(prop === obj) {
                continue;
            }

            if (typeof prop === 'object') {
                obj[i] = this.deepClone(prop, null);
            } else {
                obj[i] = prop;
            }
        }
        return obj;
    }

    setWidth(width) {
        if(width < 321) {
            this.currStyles = this.smallest;
        } else if(width < 481) {
            this.currStyles = this.small;
        } else if(width < 769) {
            this.currStyles = this.medium;
        } else if(width < 1025) {
            this.currStyles = this.normal;
        } else {
            this.currStyles = this.largest;
        }
    }

}

export default GeneralStyle



// WEBPACK FOOTER //
// src/styles/GeneralStyles.js